import { render, staticRenderFns } from "./editor-panel-title.vue?vue&type=template&id=19ce0e56"
import script from "./editor-panel-title.vue?vue&type=script&lang=js"
export * from "./editor-panel-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports